import React from "react";
import {
  Box,
  HStack,
  Flex,
  Input,
  Button,
  FormControl,
  FormLabel,
  Switch,
  Text as CText,
} from "@chakra-ui/react";

export default function Controls({
  layout,
  preview,
  setPreview,
  toggleField,
  handleSave,
}) {
  const has = {
    name: !!layout?.name,
    code: !!layout?.code,
    jobTitle: !!layout?.jobTitle,
    info: !!layout?.info,
    amount: !!layout?.amount,
    transaction: !!layout?.transaction,
  };

  return (
    <Flex direction="column" w="100%" gap={4}>
      {/* ========================== TOGGLES BAR (Horizontal) ========================== */}
      <HStack
        spacing={8}
        flexWrap="wrap"
        align="center"
        justify="flex-start"
      >
        <FormControl display="flex" alignItems="center" w="auto">
          <FormLabel mb="0">Tên</FormLabel>
          <Switch
            isChecked={has.name}
            onChange={(e) => toggleField("name", e.target.checked)}
          />
        </FormControl>

        <FormControl display="flex" alignItems="center" w="auto">
          <FormLabel mb="0">Mã NV</FormLabel>
          <Switch
            isChecked={has.code}
            onChange={(e) => toggleField("code", e.target.checked)}
          />
        </FormControl>

        <FormControl display="flex" alignItems="center" w="auto">
          <FormLabel mb="0">Chức danh</FormLabel>
          <Switch
            isChecked={has.jobTitle}
            onChange={(e) => toggleField("jobTitle", e.target.checked)}
          />
        </FormControl>

        <FormControl display="flex" alignItems="center" w="auto">
          <FormLabel mb="0">Thông tin</FormLabel>
          <Switch
            isChecked={has.info}
            onChange={(e) => toggleField("info", e.target.checked)}
          />
        </FormControl>

        <FormControl display="flex" alignItems="center" w="auto">
          <FormLabel mb="0">Giao dịch</FormLabel>
          <Switch
            isChecked={has.transaction}
            onChange={(e) => toggleField("transaction", e.target.checked)}
          />
        </FormControl>

        <FormControl display="flex" alignItems="center" w="auto">
          <FormLabel mb="0">Giá niêm yết sản phẩm</FormLabel>
          <Switch
            isChecked={has.amount}
            onChange={(e) => toggleField("amount", e.target.checked)}
          />
        </FormControl>
      </HStack>

      {/* ========================== TEXT INPUTS — Horizontal Auto-wrap ========================== */}
      <Flex gap={4} flexWrap="wrap">
        {has.name && (
          <Box w="260px">
            <CText mb={1}>Tên hiển thị</CText>
            <Input
              value={preview.name}
              onChange={(e) =>
                setPreview((p) => ({ ...p, name: e.target.value }))
              }
              placeholder="Tên sale"
            />
          </Box>
        )}

        {has.code && (
          <Box w="200px">
            <CText mb={1}>Mã nhân viên</CText>
            <Input
              value={preview.code}
              onChange={(e) =>
                setPreview((p) => ({ ...p, code: e.target.value }))
              }
              placeholder="MSNV"
            />
          </Box>
        )}

        {has.jobTitle && (
          <Box w="240px">
            <CText mb={1}>Chức danh</CText>
            <Input
              value={preview.jobTitle}
              onChange={(e) =>
                setPreview((p) => ({ ...p, jobTitle: e.target.value }))
              }
            />
          </Box>
        )}

        {has.info && (
          <Box w="300px">
            <CText mb={1}>Thông tin</CText>
            <Input
              value={preview.info}
              onChange={(e) =>
                setPreview((p) => ({ ...p, info: e.target.value }))
              }
            />
          </Box>
        )}

        {has.transaction && (
          <>
            <Box w="340px">
              <CText mb={1}>Mẫu giao dịch</CText>
              <Input
                value={preview.transactionTemplate}
                placeholder="{{so_luong_giao_dich}} Giao dịch thành công..."
                onChange={(e) =>
                  setPreview((p) => ({
                    ...p,
                    transactionTemplate: e.target.value,
                  }))
                }
              />
            </Box>

            <Box w="180px">
              <CText mb={1}>Số lượng</CText>
              <Input
                value={preview.transactionCount}
                onChange={(e) =>
                  setPreview((p) => ({
                    ...p,
                    transactionCount: e.target.value,
                  }))
                }
              />
            </Box>
          </>
        )}

        {has.amount && (
          <Box w="240px">
            <CText mb={1}>Giá niêm yết sản phẩm</CText>
            <Input
              value={preview.amount}
              onChange={(e) =>
                setPreview((p) => ({ ...p, amount: e.target.value }))
              }
            />
          </Box>
        )}
      </Flex>

      {/* ========================== SAVE BUTTON ========================== */}
      <Button colorScheme="green" onClick={handleSave} alignSelf="flex-start">
        Lưu Banner
      </Button>
    </Flex>
  );
}
